import { largeSize, mobileSize, tabletSize } from "@src/utils/screensize-helper";
import React from "react";
import colors from "@assets/colors";
import images from "@assets/images";
import SVGIcon from "@assets/svg";
import { Image, Text, View } from "react-native";
import CopyRightContent from "../signin/copy-right";
import useStyles from "./styles.css";
import UnawaProduct from "../signin/unawaProduct";

type LogoProps = {
  logoColor?: string;
  termsColor?: string;
  termsStyle?: any;
}

const Logo = (props: LogoProps) => {
  const styles = useStyles();
  const isTablet = tabletSize();
  const isMobile = mobileSize();
  const isLargeSize = largeSize();

  const size = React.useMemo(() => {
    if(isLargeSize){
      return {
        width: 320,
        height: 60,
      };
    } 
    if (isMobile){
      return {
        width: 181,
        height: 33,
      };
    }
    if (isTablet){
      return {
        width: 224,
        height: 40,
      };
    }

    return {
      width: 385,
      height: 78,
    };
  },[isLargeSize, isMobile, isTablet]);

  return (
    <View style={styles.v_logo_container}>
      <View style={{marginTop: 25 }}/>
      <SVGIcon name="ResetPassswordLogo" {...size} fill={props.logoColor}  />
      <Text style={[styles.t_logo, { color: props.logoColor}]}>The best way to {"\n"}sign online</Text>
      <UnawaProduct />
  </View>
  );
};

export default Logo;
